import { loadDynatraceRum } from './loadDynatraceRum'

loadDynatraceRum()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { UnifiedApp } from './UnifiedApp'

const el = document.getElementById('root')
if (!el) {
  throw new Error('root element missing')
}

createRoot(el).render(
  <StrictMode>
    <UnifiedApp />
  </StrictMode>,
)
